import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { Ad } from '@/api/types/common.types';
import {
  GET_MY_AD_PROMOTION_DETAILS,
  MyAdPromotionDetailsResponse,
  MyAdPromotionDetailsVariables,
} from '@/features/Profile/sections/MyAds/api';
import { getMyAdsPromotionServices } from '@/features/Profile/sections/MyAds/components/MyAdsPromotionFlow/MyAdsPromotionFlow.helpers';

type Props = {
  ad: Ad | null;
  isOpen: boolean;
};

export function useMyAdsPromotionDetails({ ad, isOpen }: Props) {
  const [
    loadPromotionDetails,
    { data: promotionDetailsData, loading, refetch },
  ] = useLazyQuery<MyAdPromotionDetailsResponse, MyAdPromotionDetailsVariables>(
    GET_MY_AD_PROMOTION_DETAILS,
    { fetchPolicy: 'network-only', errorPolicy: 'all' }
  );

  const promotionDetails = promotionDetailsData?.node;
  const hasPromotionDetailsForCurrentAd = promotionDetails?.id === ad?.id;
  const adDetails = hasPromotionDetailsForCurrentAd ? promotionDetails : null;
  const isPromotionDetailsLoading =
    loading ||
    (isOpen && !!promotionDetails && !hasPromotionDetailsForCurrentAd);
  const services = getMyAdsPromotionServices(adDetails);

  useEffect(() => {
    if (!isOpen || !ad) return;

    loadPromotionDetails({
      variables: {
        id: ad.id,
      },
    });
  }, [ad?.id, isOpen, loadPromotionDetails]);

  return {
    adDetails,
    isPromotionDetailsLoading,
    refetchPromotionDetails: refetch,
    services,
  };
}
